import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Heading = props => {

    const { backgroundColorHeader, titleEspecial, urlAssets, urlEspecial } = props;

    return (
        <section className="position-relative w-100 heading">
            <section className="stripe" style={{ background: backgroundColorHeader }}></section>
            <section className="position-absolute start-50 top-0 translate-middle-x">
                <a href={urlEspecial}>
                    <LazyLoadImage
                        alt={titleEspecial}
                        className="mt-3 img-fluid"
                        effect="blur"
                        src={`${urlAssets}/img/premiosdt2021-category.png`}
                    />
                </a>                
            </section>
        </section>
    )
}

export default Heading;

Heading.propTypes = {
    backgroundColorHeader: PropTypes.string.isRequired,
    titleEspecial: PropTypes.string.isRequired,
    urlAssets: PropTypes.string.isRequired,
    urlEspecial: PropTypes.string.isRequired
}
